<!--DOCUMENTACIÓN https://app.swaggerhub.com/apis/pdn-mx/s1-Declaraciones-Inicial/2.0#/bienesInmuebles-->
<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <!--GEMERAL-->
      <b-col sm="12">
        <h4 style="text-align: center">
          9. BIENES INMUEBLES DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO
          Y/O DEPENDIENTES ECONÓMICOS (SITUACIÓN ACTUAL)
        </h4>
      </b-col>

      <b-list-group sm="12">
        <b-list-group-item v-for="(item, index) in inmueblesFinal" :key="index">
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Inmueble</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="item.tipoOperacion==='BAJA'" sm="2">
                <b-form-group>
                  <label>Motivo Baja:</label>
                  <b-form-select
                    class="mb-3"
                    :disabled="status === 'Concluida'"
                    v-model="item.motivoBaja.clave"
                    :options="motivoBaja"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaValorBaja(index)"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Inmueble:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    v-model="item.tipoInmueble.clave"
                    :options="tipoInmueble"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaValorTipo(index)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>Porcentaje Propiedad:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.porcentajePropiedad"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <label>Superficie Terreno Valor:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.superficieTerreno.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>Superficie Terreno Unidad:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.superficieTerreno.unidad"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>Superficie Construccion:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.superficieConstruccion.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group>
                  <label>Unidad de Construcción:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.superficieConstruccion.unidad"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <label>Forma adquisicion:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    class="mb-3"
                    v-model="item.formaAdquisicion.clave"
                    :options="formaAdquisicion"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaValorAdquisicion(index)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <label>Forma pago:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.formaPago"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <label>Valor Adquisición:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.valorAdquisicion.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
               <b-col md="2">
              <b-form-group>
                <label for="moneda">Moneda:</label>
                <b-form-input
                  v-model="item.valorAdquisicion.moneda"
                  type="text"
                  value="MXN"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>

              <b-col md="4">
                <label>Fecha adquisición</label>
                <datetime
                :disabled="status === 'Concluida'"
                  :input-class="'form-control input'"
                  v-model="item.fechaAdquisicion"
                  type="date" placeholder="Selecciona fecha"
                />
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>Dato Identificacion:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.datoIdentificacion"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>Valor conforme a:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosInmueble[index].cambios = true"
                    type="text"
                    v-model="item.valorConformeA"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              
              <br />
              <!-- NACIONALIDAD -->
              <!-- <b-row md="12"> -->
              <b-col sm="3">
                <b-form-group label="Lugar donde se ubica:">
                  <b-form-radio-group 
                  :disabled="status === 'Concluida'"
                    v-model="cambiosInmueble[index].nacionalidad"
                    @change="llenaEspacios(index)"
                  >
                    <b-form-radio value="Mexico">México</b-form-radio>
                    <b-form-radio value="Extranjero">Extranjero</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <!-- </b-row> -->
              <!--FIN NACIONALIDAD -->

              <!--Mexico -->
              <b-col sm="12">
                <b-row v-if="cambiosInmueble[index].nacionalidad === 'Mexico'">
                  <b-col md="4">
                    <b-form-group>
                      <label>Calle:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioMexico.calle"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Numero Exterior:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioMexico.numeroExterior"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Numero Interior:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioMexico.numeroInterior"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group>
                      <label>Entidad Federativa:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        @change="encuentraEstadoValor(index)"
                        v-model="item.domicilioMexico.entidadFederativa.clave"
                        :options="estados"
                        text-field="valor"
                        value-field="clave"
                      ><template v-slot:first>
              <option :value="null">Selecciona
              </option>
            </template></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group>
                      <label>Municipio:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        @change="encuentraMuniValor(index)"
                        :options="cargaMunicipio(index)"
                        v-model="item.domicilioMexico.municipioAlcaldia.clave"
                        text-field="valor"
                        value-field="clave"
                      ><template v-slot:first>
              <option :value="null">Selecciona
              </option>
            </template></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group>
                      <label>Colonia Localidad:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioMexico.coloniaLocalidad"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group>
                      <label>Codigo Postal:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioMexico.codigoPostal"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <!-- Fin Mexico -->
              <!-- Extranjero -->
              <b-col sm="12">
                <b-row
                  v-if="cambiosInmueble[index].nacionalidad === 'Extranjero'"
                >
                  <b-col md="6">
                    <b-form-group>
                      <label>Calle:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.calle"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Numero Exterior:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.numeroExterior"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Numero Interior:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.numeroInterior"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group>
                      <label>Codigo Postal:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.codigoPostal"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Ciudad Localidad:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.ciudadLocalidad"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Estado Provincia:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.estadoProvincia"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Pais:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosInmueble[index].cambios = true"
                        type="text"
                        v-model="item.domicilioExtranjero.pais"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <!--Fin extranjero -->
            </b-row>
          </b-col>
          <br />
          <!-- FIN formulario -->
          <br />
          <hr />
          <!-- Titular -->
          <b-col md="12">
            <b-col md="12">
              <h6>Titulares:</h6>
            </b-col>

            <b-list-group sm="12">
              <b-list-group-item
                v-for="(item_titular, i) in inmueblesFinal[index].titular"
                :key="i"
              >
                <p style="text-align: center">{{ item_titular.valor }}</p>
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTitular(index)"
                      >Eliminar titular</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-modal
              v-if="status !== 'Concluida'"
                v-model="mostrar"
                title="Nuevo titular"
                cancel-title="Cancelar"
                ok-title="Generar"
                @ok="agregarTitular(index)"
              >
                <b-form-select
                :disabled="status === 'Concluida'"
                  v-model="tmpTitular"
                  :options="t"
                ></b-form-select>
              </b-modal>
            </b-list-group>
            <b-col md="12" >
              <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
                >Agregar Titular</b-button
              >
            </b-col>
          </b-col>
          <!-- FIN titular -->
          <br />
        
          <!-- TERCERO -->
          <b-col md="12">
            <b-col md="12">
              <h6>Terceros:</h6>
            </b-col>
            <b-list-group sm="12">
              <b-list-group-item
                v-for="(item_tercero, i) in inmueblesFinal[index].tercero"
                :key="i"
              >
                <b-row>
                  <b-col sm="2">
                    <b-form-group>
                      <label>Tipo de Persona:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        v-model="item_tercero.tipoPersona"
                        :options="tipoPersona"
                        class="mb-3"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>Nombre razón social:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_tercero.nombreRazonSocial"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>RFC:</label>
                      <b-form-input
                        type="text"
                        :disabled="status === 'Concluida'"
                        v-model="item_tercero.rfc"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      size="sm"
                      @click="tercero(item_tercero._id, index, i)"
                      >Guardar Tercero</b-button
                    >
                  </b-col>
                  <br />

                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTercero(index, i)"
                      >Eliminar tercero</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="primary"
                    size="sm"
                    @click="agregarTercero(index)"
                    >Agregar tercero</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group>
          </b-col>
          <!-- FIN tercero -->
          <br />
     
          <!-- Transmisor -->
          <b-col md="12">
            <b-col md="12">
              <h6>Transmisores:</h6>
            </b-col>
            <b-list-group>
              <b-list-group-item
                v-for="(item_transmisor, i) in inmueblesFinal[index].transmisor"
                :key="i"
              >
                <b-row>
                  <b-col sm="2">
                    <b-form-group>
                      <label>Tipo de Persona:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        v-model="item_transmisor.tipoPersona"
                        :options="tipoPersona"
                        class="mb-3"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Nombre razón social:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_transmisor.nombreRazonSocial"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>RFC:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_transmisor.rfc"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="2">
                    <b-form-group>
                      <label>Parentezco:</label>
                      <b-form-select

                      :disabled="status === 'Concluida'"
                        v-model="item_transmisor.relacion.clave"
                        :options="parentezco"
                        class="mb-3"
                        text-field="valor"
                        value-field="clave"
                        @change="seleccionaValorParentezco(index, i)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      size="sm"
                      @click="transmisor(item_transmisor._id, index, i)"
                      >Guardar Transmisor</b-button
                    >
                  </b-col>
                  <br />

                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTransmisor(index, i)"
                      >Eliminar transmisor</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="primary"
                    size="sm"
                    @click="agregarTransmisor(index)"
                    >Agregar transmisor</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group>
          </b-col>
          <!-- FIN transmisor -->
          <br />

          <b-col md="12">
            <b-row style="text-align: center">
              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="primary"
                  size="sm"
                  @click="guardarBien(index)"
                  >Guardar Inmueble</b-button
                >
                <p v-if="cambiosInmueble[index].cambios" class="error-text">
                  <i>No se han guardado los cambios</i>
                </p>
              </b-col>

              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="danger"
                  size="sm"
                  @click="eliminarBienInmueble(index)"
                  >Eliminar inmueble</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button  v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoBienInmueble()"
          >Agregar Inmueble</b-button
        >
      </b-col>
    </b-row>
    <br />

    <!--ACLARACIONES-->
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>Aclaraciones observaciones:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="inmuebles.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button  variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
      <b-button
       v-if="status !== 'Concluida'"
        variant="primary"
        @click="actualizarObservaciones()"
        :disabled="enviando"
        >Guardar cambios</b-button
      >
      <br />
      <p v-if="cambios" class="error-text">
        <i>No se han guardado los cambios</i>
      </p>
      </b-col>

      <b-col v-if="tipo=== 'INICIAL' || tipo==='CONCLUSION'" md="2" class="text-right">
        <b-button
          variant="secondary"
          @click="verSeccion(8.5)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col  v-if="tipo=== 'MODIFICACION'" md="2" class="text-right">
        <b-button
          variant="secondary"
          @click="verSeccion(8)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
          class="pull-right"
          variant="secondary"
          @click="verSeccion(10)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { muni } from "../../../store/municipios";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: { Loader, Datetime },
  props: ["inmuebles", "tipo", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      contador: 0,
      nac: "",
      contadorTercero: 1,
      contadorTransmisor: 1,
      banderaNacionalidad: "Mexico",
      inmueblesFinal: [{}],
      enviando: false,
      cambios: false,
      cambiosInmueble: [],
      agregaotro: false,
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      bandera: false,
      banderaEditar: false,
      motivoBaja: [
        { clave: "VNT", valor: "VENTA" },
        { clave: "DNC", valor: "DONACION" },
        { clave: "SNT", valor: "SINIESTRO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      formaPago: [
        { clave: "CREDITO", valor: "CRÉDITO" },
        { clave: "CONTADO", valor: "CONTADO" },
        { clave: "NO_APLICA", valor: "NO APLICA" }
      ],
      tipoInmueble: [
        { clave: "CASA", valor: "CASA" },
        { clave: "DPTO", valor: "DEPARTAMENTO" },
        { clave: "EDIF", valor: "EDIFICIO" },
        { clave: "LOCC", valor: "LOCAL COMERCIAL" },
        { clave: "BODG", valor: "BODEGA" },
        { clave: "PALC", valor: "PALCO" },
        { clave: "RACH", valor: "RANCHO" },
        { clave: "TERR", valor: "TERRENO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      formaAdquisicion: [
        { clave: "CPV", valor: "COMPRAVENTA" },
        { clave: "CSN", valor: "CESIÓN" },
        { clave: "DNC", valor: "DONACIÓN" },
        { clave: "HRN", valor: "HERENCIA" },
        { clave: "PRM", valor: "PERMUTA" },
        { clave: "RST", valor: "RIFA O SORTEO" },
        { clave: "STC", valor: "SENTENCIA" }
      ],
      tipoPersona: ["FISICA", "MORAL"],
      tmpTitular: "",
      mostrar: false,
      t: [
        "DECLARANTE",
        "CONYUGE",
        "CONCUBINA O CONCUBINARIO",
        "CONVIVIENTE",
        "DEPENDIENTE ECONÓMICO",
        "COPROPIEDAD CON TERCEROS"
      ],
      titular: [
        { clave: "DEC", valor: "DECLARANTE" },
        { clave: "CYG", valor: "CONYUGE" },
        { clave: "CBN", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CVV", valor: "CONVIVIENTE" },
        { clave: "DEN", valor: "DEPENDIENTE ECONÓMICO" },
        { clave: "CTER", valor: "COPROPIEDAD CON TERCEROS" }
      ],
      parentezco: [
        { clave: "ABU", valor: "ABUELO (A)" },
        { clave: "BISA", valor: "BISABUELO (A)" },
        { clave: "BISN", valor: "BISNIETO (A)" },
        { clave: "CONB", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CONC", valor: "CONCUÑO(A)" },
        { clave: "CONY", valor: "CÓNYUGE" },
        { clave: "CUN", valor: "CUÑADO(A)" },
        { clave: "HER", valor: "HERMANO(A)" },
        { clave: "HIJ", valor: "HIJO(A)" },
        { clave: "MAD", valor: "MADRE" },
        { clave: "PAD", valor: "PADRE" },
        { clave: "PRI", valor: "PRIMO" },
        { clave: "SOB", valor: "SOBRINO (A)" },
        { clave: "SUE", valor: "SUEGRO (A)" },
        { clave: "TATA", valor: "TATARABUELO (A)" },
        { clave: "TATN", valor: "TATARANIETO (A)" },
        { clave: "TIOA", valor: "TIO (A)" },
        { clave: "NIE", valor: "NIETO (A)" },
        { clave: "NIN", valor: "NINGUNO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      municipios: muni
    };
  },
  methods: {
    cargaMunicipio(index) {
      let listaMuni = [];
      if (Number.isInteger(index)) {
       
        if (
          this.inmueblesFinal[index].domicilioMexico.entidadFederativa.clave !==
          null
        ) {
          this.municipios.forEach(value => {
            if (
              value.claveEstado ===
              this.inmueblesFinal[index].domicilioMexico.entidadFederativa.clave
            ) {
              listaMuni.push(value);
            }
          });
        }
      }
      return listaMuni.sort();
    },
    nuevoBienInmueble() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/bienesInmuebles/" +
            this.$route.params.id +
            "/bienInmueble",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
      
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          let objeto = { _id: this.contador, cambios: false, nacionalidad: "Mexico" };
          this.cambiosInmueble.push(objeto);
          this.inmueblesFinal.push(res.data.bienInmueble);
          this.contador++;
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    llenaEspacios(index) {
      if (this.cambiosInmueble[index].nacionalidad !== "Mexico") {
        this.inmueblesFinal[index].domicilioExtranjero.calle = "";
        this.inmueblesFinal[index].domicilioExtranjero.numeroExterior = "";
        this.inmueblesFinal[index].domicilioExtranjero.numeroInterior = "";
        this.inmueblesFinal[index].domicilioExtranjero.ciudadLocalidad = "";
        this.inmueblesFinal[index].domicilioExtranjero.estadoProvincia = "";
        this.inmueblesFinal[index].domicilioExtranjero.pais = "";
        this.inmueblesFinal[index].domicilioExtranjero.codigoPostal = "";
      } else {
        this.inmueblesFinal[index].domicilioMexico.calle = "";
        this.inmueblesFinal[index].domicilioMexico.numeroInterior = "";
        this.inmueblesFinal[index].domicilioMexico.numeroExterior = "";
        this.inmueblesFinal[index].domicilioMexico.coloniaLocalidad = "";
        this.inmueblesFinal[index].domicilioMexico.municipioAlcaldia.valor = "";
        this.inmueblesFinal[index].domicilioMexico.entidadFederativa.valor = "";
        this.inmueblesFinal[index].domicilioMexico.entidadFederativa.clave = "";
        this.inmueblesFinal[index].domicilioMexico.municipioAlcaldia.clave = "";
        this.inmueblesFinal[index].domicilioMexico.codigoPostal = "";
      }
    },
    guardarBien(bien) {
      this.enviando = true;

      if (this.cambiosInmueble[bien].nacionalidad === "Mexico") {
        this.inmueblesFinal[bien].domicilioExtranjero.calle = "";
        this.inmueblesFinal[bien].domicilioExtranjero.numeroExterior = "";
        this.inmueblesFinal[bien].domicilioExtranjero.numeroInterior = "";
        this.inmueblesFinal[bien].domicilioExtranjero.ciudadLocalidad = "";
        this.inmueblesFinal[bien].domicilioExtranjero.estadoProvincia = "";
        this.inmueblesFinal[bien].domicilioExtranjero.pais = "";
        this.inmueblesFinal[bien].domicilioExtranjero.codigoPostal = "";
      } else {
        this.inmueblesFinal[bien].domicilioMexico.calle = "";
        this.inmueblesFinal[bien].domicilioMexico.numeroInterior = "";
        this.inmueblesFinal[bien].domicilioMexico.numeroExterior = "";
        this.inmueblesFinal[bien].domicilioMexico.coloniaLocalidad = "";
        this.inmueblesFinal[bien].domicilioMexico.municipioAlcaldia.clave = "";
        this.inmueblesFinal[bien].domicilioMexico.municipioAlcaldia.valor = "";
        this.inmueblesFinal[bien].domicilioMexico.entidadFederativa.clave = "";
        this.inmueblesFinal[bien].domicilioMexico.entidadFederativa.valor = "";
        this.inmueblesFinal[bien].domicilioMexico.codigoPostal = "";
      }

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/bienesInmuebles/" +
            this.$route.params.id +
            "/bienInmueble/" +
            this.inmuebles.bienInmueble[bien]._id,
          {
            tipoOperacion: this.inmueblesFinal[bien].tipoOperacion, //
            tipoInmuebleClave: this.inmueblesFinal[bien].tipoInmueble.clave, //
            tipoInmuebleValor: this.inmueblesFinal[bien].tipoInmueble.valor, //
            porcentajePropiedad: this.inmueblesFinal[bien].porcentajePropiedad, //
            superficieTerrenoValor: this.inmueblesFinal[bien].superficieTerreno
              .valor,
            superficieTerrenoUnidad: this.inmueblesFinal[bien].superficieTerreno
              .unidad,
            superficieConstruccionValor: this.inmueblesFinal[bien]
              .superficieConstruccion.valor,
            superficieConstruccionUnidad: this.inmueblesFinal[bien]
              .superficieTerreno.unidad,
            formaAdquisicionClave: this.inmueblesFinal[bien].formaAdquisicion
              .clave,
            formaAdquisicionValor: this.inmueblesFinal[bien].formaAdquisicion
              .valor,
            formaPago: this.inmueblesFinal[bien].formaPago,
            valorAdquisicionValor: this.inmueblesFinal[bien].valorAdquisicion
              .valor,
            valorAdquisicionMoneda: this.inmueblesFinal[bien].valorAdquisicion
              .moneda,
            fechaAdquisicion: this.inmueblesFinal[bien].fechaAdquisicion,
            datoIdentificacion: this.inmueblesFinal[bien].datoIdentificacion,
            valorConformeA: this.inmueblesFinal[bien].valorConformeA,
            MXcalle: this.inmueblesFinal[bien].domicilioMexico.calle,
            MXnumeroExterior: this.inmueblesFinal[bien].domicilioMexico
              .numeroExterior,
            MXnumeroInterior: this.inmueblesFinal[bien].domicilioMexico
              .numeroInterior,
            MXcoloniaLocalidad: this.inmueblesFinal[bien].domicilioMexico
              .coloniaLocalidad,
            MXentidadFederativaClave: this.inmueblesFinal[bien].domicilioMexico
              .entidadFederativa.clave,
            MXentidadFederativaValor: this.inmueblesFinal[bien].domicilioMexico
              .entidadFederativa.valor,
            MXmunicipioAlcaldiaClave: this.inmueblesFinal[bien].domicilioMexico
              .municipioAlcaldia.clave,
            MXmunicipioAlcaldiaValor: this.inmueblesFinal[bien].domicilioMexico
              .municipioAlcaldia.valor,
            MXcodigoPostal: this.inmueblesFinal[bien].domicilioMexico
              .codigoPostal,
            EXTcalle: this.inmueblesFinal[bien].domicilioExtranjero.calle,
            EXTnumeroExterior: this.inmueblesFinal[bien].domicilioExtranjero
              .numeroInterior,
            EXTnumeroInterior: this.inmueblesFinal[bien].domicilioExtranjero
              .numeroExterior,
            EXTciudadLocalidad: this.inmueblesFinal[bien].domicilioExtranjero
              .ciudadLocalidad,
            EXTestadoProvincia: this.inmueblesFinal[bien].domicilioExtranjero
              .estadoProvincia,
            EXTpais: this.inmueblesFinal[bien].domicilioExtranjero.pais,
            EXTcodigoPostal: this.inmueblesFinal[bien].domicilioExtranjero
              .codigoPostal,
            motivoBajaClave: this.inmueblesFinal[bien].motivoBaja.clave,
            motivoBajaValor: this.inmueblesFinal[bien].motivoBaja.valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         
       
          if (res.data.ok == true) {
           
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });

            this.cambiosInmueble[bien].cambios = false;

            //this.cambiosInmueble[bien].nacionalidad = this.nac;
          }
          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    checarCambios(item, indice) {
      let index = this.cambiosInmueble.findIndex(x => x._id == item._id);

      return this.cambiosInmueble[indice].cambios;
      //return false;
    },
    seRealizaronCambiios(item) {
      let index = this.cambiosInmueble.findIndex(x => x._id == item._id);
      this.cambiosInmueble[index].cambios = true;
    },
    seleccionaValorBaja(index) {
      let indice = this.motivoBaja.findIndex(
        x => x.clave == this.inmueblesFinal[index].motivoBaja.clave
      );
      this.inmueblesFinal[index].motivoBaja.valor = this.motivoBaja[
        indice
      ].valor;
    },
    seleccionaValorAdquisicion(index) {
      let indice = this.formaAdquisicion.findIndex(
        x => x.clave == this.inmueblesFinal[index].formaAdquisicion.clave
      );
      this.inmueblesFinal[index].formaAdquisicion.valor = this.formaAdquisicion[
        indice
      ].valor;
    },
    seleccionaValorTipo(index) {
      let indice = this.tipoInmueble.findIndex(
        x => x.clave == this.inmueblesFinal[index].tipoInmueble.clave
      );
      this.inmueblesFinal[index].tipoInmueble.valor = this.tipoInmueble[
        indice
      ].valor;
    },
    encuentraEstadoValor(index) {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.inmueblesFinal[index].domicilioMexico.entidadFederativa.clave
      );
      this.inmueblesFinal[
        index
      ].domicilioMexico.entidadFederativa.valor = this.estados[indice].valor;
      
    },
    encuentraMuniValor(index) {
      let indice;
      indice = this.municipios.findIndex(
        x =>
          x.clave ===
          this.inmueblesFinal[index].domicilioMexico.municipioAlcaldia.clave
      );
      this.inmueblesFinal[
        index
      ].domicilioMexico.municipioAlcaldia.valor = this.municipios[indice].valor;
    },
    seleccionaValorParentezco(index, i) {
      let indice = this.parentezco.findIndex(
        x => x.clave == this.inmueblesFinal[index].transmisor[i].relacion.clave
      );
      this.inmueblesFinal[index].transmisor[i].relacion.valor = this.parentezco[
        indice
      ].valor;
    },
    seleccionaValorTitular(index, i) {
      let indice = this.titular.findIndex(
        x => x.clave == this.inmueblesFinal[index].titular[i].clave
      );
      this.inmueblesFinal[index].titular[i].valor = this.titular[indice].valor;
    },
    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/bienesInmuebles/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.inmuebles.aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
         
        });
    },
    eliminarBienInmueble(index) {
      swal({
        text: "¿Está seguro en eliminar el inmueble?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesInmuebles/" +
                this.$route.params.id +
                "/bienInmueble/" +
                this.inmuebles.bienInmueble[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
           
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.inmuebles.bienInmueble.splice(index, 1);
                this.cambiosInmueble.splice(index, 1);
                this.contador--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
          
            });
        }
      });
    },
    agregarTitular(index) {
    let indice = this.titular.findIndex(
        x => x.valor == this.tmpTitular
      );
      let nuevoTitular = {
        clave: this.titular[indice].clave,
        valor: this.tmpTitular
      };
      this.inmueblesFinal[index].titular.push(nuevoTitular);
    

      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/bienesInmuebles/" +
            this.$route.params.id +
            "/bienInmueble/" +
            this.inmueblesFinal[index]._id +
            "/titular",

          {
            titularClave: this.titular[indice].clave,
            titularValor: this.tmpTitular
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
      
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });



    },
    agregarTercero(index) {
      let nuevoTercero = {
        _id: this.contadorTercero,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
      };
      this.inmueblesFinal[index].tercero.push(nuevoTercero);
      this.contadorTercero++;
    },
    agregarTransmisor(index) {
      let nuevoTransmisor = {
        _id: this.contadorTransmisor,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null,
        relacion: { descripcion: null, clave: null, valor: null }
      };
      this.inmueblesFinal[index].transmisor.push(nuevoTransmisor);
      this.contadorTransmisor++;
    },
    guardarTitular(index, i) {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/bienesInmuebles/" +
            this.$route.params.id +
            "/bienInmueble/" +
            this.inmueblesFinal[index]._id +
            "/titular",

          {
            titularClave: this.inmueblesFinal[index].titular[i].clave,
            titularValor: this.inmueblesFinal[index].titular[i].valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    tercero(id, index, i) {
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/bienesInmuebles/" +
              this.$route.params.id +
              "/bienInmueble/" +
              this.inmueblesFinal[index]._id +
              "/tercero",

            {
              tipoPersona: this.inmueblesFinal[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.inmueblesFinal[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.inmueblesFinal[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
        
            this.banderaEditar = true;
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.inmueblesFinal[index].tercero[i]._id = res.data.tercero._id;
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/bienesInmuebles/" +
              this.$route.params.id +
              "/bienInmueble/" +
              this.inmueblesFinal[index]._id +
              "/tercero/" +
              id,
            {
              tipoPersona: this.inmueblesFinal[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.inmueblesFinal[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.inmueblesFinal[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
       
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.enviando = false;
            }
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      }
    },
    transmisor(id, index, i) {
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/bienesInmuebles/" +
              this.$route.params.id +
              "/bienInmueble/" +
              this.inmueblesFinal[index]._id +
              "/transmisor",
            {
              relacionClave: this.inmueblesFinal[index].transmisor[i].relacion
                .clave,
              relacionValor: this.inmueblesFinal[index].transmisor[i].relacion
                .valor,
              tipoPersona: this.inmueblesFinal[index].transmisor[i].tipoPersona,
              nombreRazonSocial: this.inmueblesFinal[index].transmisor[i]
                .nombreRazonSocial,
              rfc: this.inmueblesFinal[index].transmisor[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
 
            this.banderaEditar = true;
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.inmueblesFinal[index].transmisor[i]._id =
              res.data.transmisor._id;
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/bienesInmuebles/" +
              this.$route.params.id +
              "/bienInmueble/" +
              this.inmueblesFinal[index]._id +
              "/transmisor/" +
              id,
            {
              relacionClave: this.inmueblesFinal[index].transmisor[i].relacion
                .clave,
              relacionValor: this.inmueblesFinal[index].transmisor[i].relacion
                .valor,
              tipoPersona: this.inmueblesFinal[index].transmisor[i].tipoPersona,
              nombreRazonSocial: this.inmueblesFinal[index].transmisor[i]
                .nombreRazonSocial,
              rfc: this.inmueblesFinal[index].transmisor[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
 
 
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo transmisor."
            });
            this.enviando = false;
          });
      }
    },
    eliminarTitular(index, i) {
  
  
      swal({
        text: "¿Está seguro en eliminar el titular?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesInmuebles/" +
                this.$route.params.id +
                "/bienInmueble/" +
                this.inmueblesFinal[index]._id +
                "/titular/" +
                this.inmueblesFinal[index].titular[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
           
              this.inmueblesFinal[index].titular.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },
    eliminarTercero(index, i) {
      swal({
        text: "¿Está seguro en eliminar tercero?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesInmuebles/" +
                this.$route.params.id +
                "/bienInmueble/" +
                this.inmueblesFinal[index]._id +
                "/tercero/" +
                this.inmueblesFinal[index].tercero[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
        
              this.inmueblesFinal[index].tercero.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },
    eliminarTransmisor(index, i) {
      swal({
        text: "¿Está seguro en eliminar transmisor?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesInmuebles/" +
                this.$route.params.id +
                "/bienInmueble/" +
                this.inmueblesFinal[index]._id +
                "/transmisor/" +
                this.inmueblesFinal[index].transmisor[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
          
              this.inmueblesFinal[index].transmisor.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
             
            });
        }
      });
    }
  },
  watch: {},

  created() {
 
    this.inmueblesFinal = this.inmuebles.bienInmueble;


    this.inmueblesFinal.forEach(Element => {
      if (
        Element.domicilioMexico.calle === "" ||
        Element.domicilioMexico.calle === null
      ) {
        let objeto = {
          _id: Element._id,
          cambios: false,
          nacionalidad: "Extranjero"
        };
        this.cambiosInmueble.push(objeto);
      } else if (Element.domicilioExtranjero.calle === "" || Element.domicilioExtranjero.calle===null) {
        let objeto = {
          _id: Element._id,
          cambios: false,
          nacionalidad: "Mexico"
        };
        this.cambiosInmueble.push(objeto);
      }
      if (Element.tipoOperacion === "AGREGAR") {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
